import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sa-stats position-relative" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "sa-stat-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "trezo-card-content d-flex justify-content-between" }
const _hoisted_6 = { class: "d-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (stat, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-sm-4",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(stat.label), 1),
                  _createElementVNode("h3", null, _toDisplayString(stat.value), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(['trezo-badge', stat.badgeClass])
                  }, _toDisplayString(stat.change), 3)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass([
                  'icon d-flex align-items-center justify-content-center rounded-circle',
                  stat.iconColor,
                  stat.bgColor,
                ])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(stat.icon)
                  }, null, 2)
                ], 2)
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}